import apiClient from '../utils/apiClient';

export const auditLogsApi = {
  getAll: (params = {}) => apiClient.get('/audit-logs', { params }).then(res => res.data),
  getById: (id) => apiClient.get(`/audit-logs/${id}`).then(res => res.data)
};
